import React, { useState } from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Header({ title }) {
  const [activeLink, setActiveLink] = useState(title);
  const navigate = useNavigate();
  const handleNavItemClick = (item) => {
    setActiveLink(item);
  };

  const Logostyle = {
    height: "80px",
    width: "100%",
    maxwidth: "100%",
    marginBottom: "20px",
    marginTop: "10px",
  };
  return (
    <Navbar expand="lg" className="bg-body-tertiary" style={{ marginTop: 0 }}>
      <Container
        fluid
        style={{ margin: "-8px 0 0 0", padding: 0, backgroundColor: "#172446" }}
      >
        <Navbar.Brand href="#home" style={{ color: "white" }}>
          <img
            src={process.env.PUBLIC_URL + "/assets/images/HeaderLogo.png"}
            style={Logostyle}
            alt=""
          />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="custom-toggler"
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              // href="/"
              onClick={() => {
                handleNavItemClick("home");
                navigate("/");
              }}
              style={{
                color: activeLink === "home" ? "#FFE114" : "white",
                paddingLeft: "15px",
                paddingRight: "50px",
              }}
            >
              Home
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                handleNavItemClick("about");
                navigate("/About");
              }}
              style={{
                color: activeLink === "about" ? "#FFE114" : "white",
                paddingLeft: "15px",
                paddingRight: "50px",
              }}
            >
              About
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                handleNavItemClick("vacancies");
                navigate("/Vacancies");
              }}
              style={{
                color: activeLink === "vacancies" ? "#FFE114" : "white",
                paddingLeft: "15px",
                paddingRight: "50px",
              }}
            >
              Vacancies
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                handleNavItemClick("blog");
                navigate("/Blogs");
              }}
              style={{
                color: activeLink === "blog" ? "#FFE114" : "white",
                paddingLeft: "15px",
                paddingRight: "50px",
              }}
            >
              Blog
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                handleNavItemClick("success");
                navigate("/SuccessStories");
              }}
              style={{
                color: activeLink === "success" ? "#FFE114" : "white",
                paddingLeft: "15px",
                paddingRight: "50px",
              }}
            >
              Our Clients
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                handleNavItemClick("contact");
                navigate("/ContactUs");
              }}
              style={{
                color: activeLink === "contact" ? "#FFE114" : "white",
                paddingLeft: "15px",
                paddingRight: "150px",
              }}
            >
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
